import { render } from "./app.vue?vue&type=template&id=fe1a685e"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=fe1a685e&lang=postcss"
script.render = render

export default script